import { Box, Button } from "@material-ui/core";
import React, { useEffect } from "react";
import ActivationLayout from "../../../components/Layout";
import { RouteComponentProps } from "@reach/router";
import ActivationHeading from "../../../components/ActivationHeading";
import { Link } from "gatsby";
import { getActivationPath } from "../../../utils/url";
import useRequireAuthenticated from "../../../hooks/useRequireAuthenticated";
import useRequireUnlockAllowed from "../../../hooks/useRequireUnlockAllowed";
import FadeInUp from "../../../../../components/animations/FadeInUp";
import { analyticsTrackEvent } from "../../../../../services/analytics";

type Props = RouteComponentProps<{ podKeyOrSerialNumber: string }>;

export default function ActivationStep4ActivationInfo({
  podKeyOrSerialNumber
}: Props) {
  useRequireAuthenticated();
  const isUnlockAllowed = useRequireUnlockAllowed();

  return (
    <ActivationLayout showLoading={!isUnlockAllowed} fullHeight>
      <Box>
        <FadeInUp yOffset={-10} delay={0}>
          <Box display="flex">
            <ActivationHeading>Thank you.</ActivationHeading>
          </Box>
        </FadeInUp>

        <FadeInUp yOffset={-10} delay={0.75}>
          <Box mt={4} display="flex">
            <ActivationHeading>
              You’re now ready to unlock your pod.
            </ActivationHeading>
          </Box>
        </FadeInUp>

        <FadeInUp yOffset={-10} delay={1.5}>
          <Box mt={4} display="flex">
            <ActivationHeading>
              There will be magic.
              <br />
              There will be light.
            </ActivationHeading>
          </Box>
        </FadeInUp>
      </Box>

      <Box marginTop={{ xs: 4, md: 6 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          component={Link}
          to={getActivationPath(`${podKeyOrSerialNumber}/activation-light`)}
        >
          {"Unlock my pod"}
        </Button>
      </Box>
    </ActivationLayout>
  );
}
